import { render, staticRenderFns } from "./atcCounterpart.vue?vue&type=template&id=4e7f4e51&"
import script from "./atcCounterpart.vue?vue&type=script&lang=ts&"
export * from "./atcCounterpart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports